/**
  * Bug #503
  * @Author Anupama P
  * @Date 06 Sep 2021
  */
 import { Col, Row, CommonInputLabel, InputItem, generateGender, Select } from 'components'
 import { getKeyName } from 'shared/utils/formlocalization'
 
 interface Props {
   preFix?: String;
   keyName?: any;/*For saving insurance subscriber Address fields - Author Aby Joseph on 16 Sep 2021*/
   gridValues?:any;
   onAccordionFieldChange?: any;
 }

 const defaultProps = {
   onAccordionFieldChange: () => { return Promise.resolve() }
 };

 const Gender = (props: Props) => {
     return (
       <Col sm={12} md={4} lg={4} {...props?.gridValues?.container}>
       <Row>
         {/* <CommonInputLabel label="Gender"/> */}
       
         <Col sm={12} md={12} lg={12} {...props?.gridValues?.col}>
           <InputItem  label="Gender"
             //name={[props?.preFix, getKeyName(props?.keyName, "gender")]}
             name={
               props?.preFix
                   ? [props?.preFix, getKeyName(props?.keyName, "gender")]
                   : getKeyName(props?.keyName, "gender")/*For saving insurance subscriber Address fields - Author Aby Joseph on 16 Sep 2021*/
             }
             rules={[
               {
                 required: true,
                 message: "Enter Gender",
               }, 
               { validator: props.onAccordionFieldChange }
             ]}
           >
             <Select>{generateGender()}</Select>
           </InputItem>
         </Col>
       </Row>
     </Col>
     )
 }
 
 Gender.defaultProps = defaultProps;
 export default Gender
 